import { SheetContainer } from "./SheetContainer";
import { strings } from "../strings";

// CheckCircle icon SVG
function CheckCircleIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <circle cx="12" cy="12" r="10" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  );
}

export interface CompleteSheetProps {
  className?: string;
}

export function CompleteSheet({ className }: CompleteSheetProps) {
  return (
    <SheetContainer className={`gap-6 ${className || ""}`}>
      {/* Header */}
      <div>
        <div className="flex items-center gap-3 mb-4">
          <CheckCircleIcon className="w-6 h-6 text-green-600" />
          <h2 className="text-2xl font-semibold text-foreground">
            {strings.completeSheet.title}
          </h2>
        </div>

        <div className="text-muted-foreground text-left flex flex-col gap-3">
          <p className="text-base">{strings.completeSheet.description1}</p>
          <p className="text-base">{strings.completeSheet.description2}</p>
          <p className="text-base font-medium text-foreground">
            {strings.completeSheet.closeHint}
          </p>
        </div>
      </div>
    </SheetContainer>
  );
}
